// Dropdown functionality, developed for the navigation top primary menu on desktop

// Initializes the dropdown functionality
function initialize() {

  const dropdownDelay = 400;

  const dropdownGroupSelector = '.wf-dropdown-group';
  const dropdownItemSelector = '.wf-dropdown-item';
  const dropdownItemToggleSelector = '.wf-dropdown-item-toggle';
  const dropdownItemActiveClassName = 'wf-dropdown-item-active';

  const dropdownItems = document.querySelectorAll(dropdownItemSelector);
  const dropdownToggles = document.querySelectorAll(dropdownItemToggleSelector);

  var dropdownTimeout = null; 

  // Activate/deactivate dropdown items on mouse enter/leave
  dropdownItems.forEach(currentItem => {
    currentItem.addEventListener('mouseenter', event => {
      if (dropdownTimeout){
        clearTimeout(dropdownTimeout);
      }
      dropdownTimeout = setTimeout(function(){
        activateDropdownItem(currentItem);
      }, dropdownDelay);
    });

    currentItem.addEventListener('mouseleave', event => {
      if (dropdownTimeout){
        clearTimeout(dropdownTimeout);
      }
      deactivateDropdownItem(currentItem);
    });
  });

  // Activate dropdown items on toggle click
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', event => {
      const dropdownItem = toggle.closest(dropdownItemSelector);
      const dropdownGroup = toggle.closest(dropdownGroupSelector);
      const dropdownGroupItems = dropdownGroup.querySelectorAll(dropdownItemSelector);

      // Ensure all other dropdowns in the group are deactivated
      dropdownGroupItems.forEach(item => {
        if (item !== dropdownItem) {
          deactivateDropdownItem(item);
        }
      });

      activateDropdownItem(dropdownItem);
    });
  });

  // Close all dropdowns when escape key is pressed
  document.onkeydown = (event => {
    event = event || window.event;
    if (event.key === 'Escape') {
      dropdownItems.forEach(item => {
        deactivateDropdownItem(item);
      });
    }
  });

  // Activates the specified dropdown
  function activateDropdownItem(item) {
    item.classList.add(dropdownItemActiveClassName);
  }
  
  // Deactivates the specified dropdown
  function deactivateDropdownItem(item) {
    item.classList.remove(dropdownItemActiveClassName);
  }
}

initialize();
